import { render, staticRenderFns } from "./ActivityDetailsPageLink.vue?vue&type=template&id=0b20b514&"
import script from "./ActivityDetailsPageLink.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailsPageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports